import styled from "styled-components";

export const WarningWrapper = styled.div`
  display: block;
  text-align: left;
  height: 90px;
  padding-top: 24px;
  top: 0px;
  background-color: ${({ theme }) => theme.colorTokens.white};
  padding-bottom: 0px;
`;
